import {
  CompartmentRuleDeleteItemsParams,
  CompartmentRuleItemCreateParams,
  CompartmentRuleItemParams,
  CompartmentRuleItemURIParams,
  CompartmentRuleItemGetDocksParams,
  CompartmentRuleItemGetCarriersParams,
  CompartmentRuleDeleteItemParams,
} from '../../../models/compartment-rule-item.model';

export class CompartmentRuleItemLoad {
  public static readonly type = '[CompartmentRuleItem] Load';
  constructor(public payload: CompartmentRuleItemURIParams) {}
}

export class CompartmentRuleItemCreate {
  public static readonly type = '[CompartmentRuleItem] Create';
  constructor(public payload: CompartmentRuleItemCreateParams) {}
}

export class CompartmentRuleItemUpdate {
  public static readonly type = '[CompartmentRuleItem] Update';
  constructor(public payload: CompartmentRuleItemParams) {}
}

export class CompartmentRuleItemGetDocks {
  public static readonly type = '[CompartmentRuleItem] Get Docks';
  constructor(public payload: CompartmentRuleItemGetDocksParams) {}
}

export class CompartmentRuleItemGetCarriers {
  public static readonly type = '[CompartmentRuleItem] Get Carriers';
  constructor(public payload: CompartmentRuleItemGetCarriersParams) {}
}

export class CompartmentRuleItemGetPickupAddresses {
  public static readonly type = '[CompartmentRuleItem] Get Pickup Addresses';
  constructor(public payload: CompartmentRuleItemGetCarriersParams) {}
}

export class CompartmentRuleItemGetDeliveryAddresses {
  public static readonly type = '[CompartmentRuleItem] Get Delivery Addresses';
  constructor(public payload: CompartmentRuleItemGetCarriersParams) {}
}

export class CompartmentRuleItemsDelete {
  public static readonly type = '[CompartmentRuleItems] Delete';
  constructor(public payload: CompartmentRuleDeleteItemsParams) {}
}

export class CompartmentRuleItemDelete {
  public static readonly type = '[CompartmentRuleItem] Delete';
  constructor(public payload: CompartmentRuleDeleteItemParams) {}
}

export class CompartmentRuleItemInitialState {
  public static readonly type = '[CompartmentRuleItem] Set initial state';
}
